jQuery(document).ready(function($) {
    $(document).on('mouseover', 'input[datetimepicker]:not(.js-has-datetimepicker)', function() {
        $(this)
            .attr('autocomplete', 'off')
            .addClass('js-has-datetimepicker')
            .datetimepicker({
                format: "Y-m-d H:i:00",
                todayBtn: "linked",
                todayHighlight: true,
                step: 10,
            });
    });

    $(document).on('mouseover', 'input[datepicker]:not(.js-has-datepicker)', function() {
        $(this)
            .attr('autocomplete', 'off')
            .addClass('js-has-datepicker')
            .datetimepicker({
                timepicker: false,
                format: "Y-m-d",
                todayBtn: "linked",
                todayHighlight: true,
                step: 10,
            });
    });
});

jQuery.event.special.clicks = {
    idle: 0,

    setup: function(data, namespaces) {
        var elem = this, $elem = jQuery(elem);
        $elem.bind('click', jQuery.event.special.clicks.handler);
    },

    teardown: function(namespaces) {
        var elem = this, $elem = $(elem);
        $elem.unbind('click', jQuery.event.special.clicks.handler)
    },

    handler: function(event) {
        var elem = this, $elem = jQuery(elem), clicks = $elem.data('clicks') || 0, idle = $elem.data('clicksidle');
        
        clicks += 1;
        
        // set event type to "clicks"
        event.type = "clicks";

        // set event numbers
        event.times = clicks;

        // let jQuery handle the triggering of "clicks" event handlers
        jQuery.event.dispatch.apply(this, arguments);

        $elem.data('clicks', clicks);

        clearTimeout(idle);

        idle = setTimeout(function() {
            clicks = 0;
            $elem.data('clicks', clicks);
        }, 500);

        $elem.data('clicksidle', idle);
    }
};

function setToothState(id, $tooth, state, identifier) {
    // Find all teeth with the same id
    var $teeth = $('#' + id + ' [data-id="' + $tooth.data('id') + '"][role="tooth"]');

    var selected = !$tooth.attr('selected');

    // Toggle selected state
    $teeth.attr('selected', selected);

    // Set state value
    $teeth.attr('state', state);

    var $fields = $(identifier + '.schema-fields');
    
    $fields.find('[name^="Tag[' + $tooth.data('id') + ']"][role="tooth"]').remove();

    if (selected) {
        $fields.append('<input type="hidden" name="Tag[' + $tooth.data('id') + '][name]" value="' + $tooth.data('id') + '" role="tooth" />');
        $fields.append('<input type="hidden" name="Tag[' + $tooth.data('id') + '][value]" value="' + (state - 1) + '" role="tooth" />');
    }

    $(identifier + '[name="Product[quantity]"][multiply]').val(($fields.first().find('[name^="Tag"][role="tooth"]').length / 2) || '');
    $(identifier + '[name="Product[quantity]"]:not([multiply])').val($fields.first().find('[name^="Tag"][role="tooth"]').length ? 1 : '');
}

function selectBridge(id, $bridge, identifier) {
    var selected = !$bridge.attr('selected');
    
    // Toggle selected state
    $bridge.attr('selected', selected);

    // Get points
    var points = $bridge.data('id').split('-');

    points.forEach(function(point) {
        var $point = $('#' + id + ' [data-id="' + point + '"][role="point"]');

        // Toggle selected
        $point.attr('selected', selected);
    });

    var $fields = $(identifier + '.schema-fields');
    
    $fields.find('[name^="Tag[' + $bridge.data('id') + ']"][role="bridge"]').remove();

    if (selected) {
        $fields.append('<input type="hidden" name="Tag[' + $bridge.data('id') + '][name]" value="' + $bridge.data('id') + '" role="bridge" />');
        $fields.append('<input type="hidden" name="Tag[' + $bridge.data('id') + '][value]" value="bridge" role="bridge" />');
    }
}
